import { useCallback } from "react";

/**
 * Hook for showing a confirmation dialog
 * @param {string} message - The confirmation message
 * @param {Function} onConfirm - Callback when user confirms
 * @param {Function} onCancel - Callback when user cancels (optional)
 * @returns {Function} Function to trigger the confirmation
 */
export const useConfirmDialog = (message, onConfirm, onCancel = () => {}) => {
  const confirmAction = useCallback(() => {
    if (window.confirm(message)) {
      onConfirm();
    } else {
      onCancel();
    }
  }, [message, onConfirm, onCancel]);

  return confirmAction;
};

export default useConfirmDialog;
